import React from 'react';
import { observer } from 'mobx-react';
import { Tooltip, Fab } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CancelWorkFlowCommandName } from './const';
import { CancelWorkFlowCommandProps } from './types';
import useData from './hooks';
import { CancelWorkFlowCommandStyledComponent } from './styles';
import ConfirmDialog from '10.quickConnect.app/components/shared/LayOut/ConfirmDialog';

const CancelWorkFlowCommand = ({
  formType,
  handleItemDatas,
  sendDeclaration,
  setDeclarationData,
  declarationId,
}: CancelWorkFlowCommandProps) => {
  const { t, onCancelWorkflow, openConfirmDialog, handleOpenConfirmDialog, handleCloseConfirmDialog } = useData(
    formType,
    handleItemDatas,
    sendDeclaration,
    setDeclarationData,
    declarationId,
  );

  return (
    <>
      <Tooltip title={t('formlib_cancel_workflow_button_text').toString()} placement="right">
        <CancelWorkFlowCommandStyledComponent
          data-cy={`${CancelWorkFlowCommandName}-btn-cancelWkf`}
          size="large"
          onClick={handleOpenConfirmDialog}
          color="warning"
        >
          <DeleteOutlineIcon />
        </CancelWorkFlowCommandStyledComponent>
      </Tooltip>

      <ConfirmDialog
        open={openConfirmDialog}
        close={handleCloseConfirmDialog}
        actionForLabelOne={onCancelWorkflow}
        actionLabelOne={t('qcapp_button_yes').toString()}
        cancelLabel={t('qcapp_button_no').toString()}
        title={t('formlib_cancel_workflow_confirm_title').toString()}
        subtitle={t('formlib_cancel_workflow_confirm_message').toString()}
        sendingData={false}
      />
    </>
  );
};

export default observer(CancelWorkFlowCommand);
